import { render, staticRenderFns } from "./StoreFurnishing.vue?vue&type=template&id=061f77ac&scoped=true&"
import script from "./StoreFurnishing.vue?vue&type=script&lang=js&"
export * from "./StoreFurnishing.vue?vue&type=script&lang=js&"
import style0 from "./StoreFurnishing.vue?vue&type=style&index=0&id=061f77ac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061f77ac",
  null
  
)

export default component.exports